<template>
<table class="table" id="myTable">
    <tr class="table__row--heading">
        <th class="table__heading" 
            :class="{'table__sortable js-table__sortable': column.sortable,}" 
            v-on="column.sortable ? { click: sort } : {}"
            v-for="column in table.columns" 
            :key="column.id">
            {{column.title}}
        </th>
    </tr>
    <tr class="table__row" v-for="row in table.rows" :key="row.id">
        <td class="table__cell" v-for="cell in row" :key="cell.id">{{cell}}</td>
    </tr>
</table>
</template>

<script>
export default {
    props: {
        table: { type: Object, default: null },
        date_uk: { type: Boolean, default: false },
    },
    methods: {
        indexInParent(node) {
            var children = node.parentNode.childNodes;
            var num = 0;
            for (var i = 0; i < children.length; i++) {
                if (children[i] == node)
                    return num;
                if (children[i].nodeType == 1)
                    num++;
            }
            return -1;
        },
        sorter(a, b){
            if (a < b) return -1;  // any negative number works
            if (a > b) return 1;   // any positive number works
            return 0;
        },
        reverser(a, b){
            if (a < b) return 1;  // any negative number works
            if (a > b) return -1;   // any positive number works
            return 0;
        },
        getDate(val) {
            let date = new Date(val);
            let dd = date.getDate();
            let mm = date.getMonth()+1; 
            let yyyy = date.getFullYear();

            dd < 10 ? dd = '0' + dd : ''
            mm < 10 ? mm = '0' + mm : ''

            date = this.date_uk ? dd + '/' + mm + '/' + yyyy : mm + '/' + dd + '/' + yyyy

            return date
        },
        sort(e) {
            const userKeyRegExp = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}?$/;
            const userKeyRegExp2 = /^[0-9]{2}-[0-9]{2}-[0-9]{4}?$/;

            let i = 0;
            let arr = [];
            let arr2 = [];
            let arr3 = [];
            let table = e.target.closest('table');
            let columnIndex = this.indexInParent(e.target);
            let dir = "asc";
            let rows = Array.from(table.querySelectorAll(`tr`));
            //gets all values from chosen column
            rows = rows.slice(1);
            rows.forEach(element => {
                let value = element.getElementsByTagName('td')[columnIndex].innerHTML
                if(this.date_uk && (userKeyRegExp.test(value) || userKeyRegExp2.test(value))){
                    value = value.split('/')[1] + '/' + value.split('/')[0] + '/' + value.split('/')[2];
                }
                let isnum = /^\d+$/.test(value);
                let isdate = !Date.parse(value);

                isnum ? arr.push(parseInt(value)) : !isdate ? arr.push(new Date(Date.parse(value))) : arr.push(value)
            });
            //sets the order to be sorted by
            !e.target.classList.contains('asc') && !e.target.classList.contains('desc') ? 
            dir = 'asc' :
            !e.target.classList.contains('asc') ?
            dir = 'asc' : dir = 'desc'
            //sorts column values in ascending or descending order
            dir == 'asc' ? arr2 = arr.sort(this.sorter) : arr2 = arr.sort(this.reverser)
            //sets all rows in correct order to be inserted into table
            for (let i = 0; i < arr2.length; i++) {
                for (let j = 0; j < rows.length; j++) {
                    const element = rows[j];
                    let qs = `td:nth-child(${columnIndex + 1})`;
                    let t1 = element.querySelector(qs);
                    
                    if( typeof arr2[i] == 'object' ) {                        
                        t1.innerHTML == this.getDate(arr2[i]) ? arr3.push(rows[j]) : null
                    } else {
                        t1.innerHTML == arr2[i] ? arr3.push(rows[j]) : null
                    }
                    
                }
            }
            //deletes all rows
            for( i = table.rows.length - 1; i > 0; i--){
                table.deleteRow(i);
            }
            //inserts rows in sorted order
            arr3.forEach(row => {
                table.appendChild(row)
            });

            //adds class to the heading row
            if (!e.target.classList.contains('asc') && !e.target.classList.contains('desc')) {
                const headings = document.getElementsByClassName('js-table__sortable')
                headings.forEach((el) => {
                    el.classList.remove('asc', 'desc');
                })
                e.target.classList.add('asc');
            } else {
                e.target.classList.toggle('asc');
                e.target.classList.toggle('desc');
            }
        }
    }
}   
</script>